import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  GetCompanyHandlerParams,
  TCompanyHandlersResponse,
} from './useGetCompanyHandler';

const useListAllCompanyHandlers = (
  params: GetCompanyHandlerParams | null = {}
) => {
  const { companyIds, type, extends: extendsFields } = params || {};

  // Build query string
  const queryParams = new URLSearchParams();

  if (companyIds && companyIds.length > 0) {
    companyIds.forEach((id) => queryParams.append('companyIds', id.toString()));
  }

  if (type) {
    queryParams.append('type', type);
  }

  if (extendsFields && extendsFields.length > 0) {
    extendsFields.forEach((field) => queryParams.append('extends', field));
  }

  const queryString = queryParams.toString();
  const requestURL = queryString
    ? `company-handlers?${queryString}`
    : 'company-handlers';

  const { data, error, isLoading, mutate } = useSWR(
    params ? requestURL : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    data: data as TCompanyHandlersResponse | undefined,
    error,
    isLoading,
    mutate,
  };
};

export default useListAllCompanyHandlers;
